const APP = {
  INIT: 'APP.INIT', // the first action that dispatches in the app
  SET_ID: 'APP.SET_ID', // sets the current megogo's object id
  SET_DATA_READY: 'APP.SET_DATA_READY', // when true, means that all data fetched for current movie and containers could render
  RESET_SUBSCRIPTIONS_VIDEO_COLLECTIONS: 'APP.RESET_SUBSCRIPTIONS_VIDEO_COLLECTIONS', // reset store's state for subscription & videoCollection to initial values
  FORCE_DATA_UPDATE: 'APP.FORCE_DATA_UPDATE', // forces reloading of all movie depended data, also resets 'dataReady' to false
  RESET_SERVICE_API_DATA: 'APP.RESET_SERVICE_API_DATA', // resets some specific part of store's state, in payload should be name of that 'specific store's part'
  REMOVE_API_RESPONSE_ERROR: 'APP.REMOVE_API_RESPONSE_ERROR', // removes error object from store that had got from api response
  SET_PATHNAME: 'APP.SET_PATHNAME', // sets current pathname
  FORCE_LOGOUT: 'APP.FORCE_LOGOUT',
  SAVE_MOVIE_POSITION: 'APP.SAVE_MOVIE_POSITION',
  LOGIN_INPUT_VALUE: 'APP.LOGIN_INPUT_VALUE', // get value login input
  SET_UA: 'APP.SET_UA', // USe Agent
  HAS_STORAGE_ACCESS: 'APP.HAS_STORAGE_ACCESS',
};

export default APP;
